import React from 'react'
import dayjs from 'dayjs'
import { Button } from 'antd'
import { StopOutlined } from '@ant-design/icons'
import { ListCard, ListChip, ListMedia } from '../card_list/CardList'
import { storeLocal } from '../../helpers/stores'
import i from '../../translations/i'

// Карточка проекта (строка kssettings) в «Мои проекты» и «Все проекты» суперадминки: имя, ID, бандл,
// тариф, оплата, чёрная метка. В проект ведёт клик по любому месту карточки — по названию, иконке, кнопке

export interface ProjectRow {
    id: number
    name: string | null
    bandl: string
    pricing_plan: number
    datepayend: number
    // Из /manager/projects приходит как 0/1
    black_mark: boolean | number
}

const PLAN_NAMES = ['first', 'second', 'third', 'fourth']

const planName = (plan: number) => PLAN_NAMES[plan] ? i.t(`def:ratesName.${PLAN_NAMES[plan]}`) : `${plan}`

const PaidChip = ({ project }: { project: ProjectRow }) => {
    if (!project.datepayend) return <ListChip tone="danger">{i.t('superAdmin:projects.notPaid')}</ListChip>

    const until = dayjs.unix(project.datepayend)
    const expired = until.isBefore(dayjs())

    return (
        <ListChip tone={expired ? 'danger' : 'success'} tooltip={expired ? i.t('superAdmin:projects.expired') : undefined}>
            {`${i.t('superAdmin:projects.paidUntil')} ${until.format('DD.MM.YYYY')}`}
        </ListChip>
    )
}

// Поиск по названию, бандлу или ID; query — в нижнем регистре, без пробелов по краям
export const projectMatches = (project: ProjectRow, query: string) =>
    `${project.id}` === query
    || (project.name ?? '').toLowerCase().includes(query)
    || (project.bandl ?? '').toLowerCase().includes(query)

export const ProjectCard = ({ project, bundle = true, chips, disabled, onOpen }: {
    project: ProjectRow
    // Показывать ли бандл: продавцу маркетплейса он ни к чему
    bundle?: boolean
    chips?: React.ReactNode
    // Проект не открыть (например, нет базы): ни карточка, ни кнопка в него не ведут
    disabled?: boolean
    onOpen: () => void
}) => {
    const current = project.bandl === storeLocal.get('bundle')
    const blackMark = !!+project.black_mark

    return (
        <ListCard
            media={<ListMedia icon={`${project.name ?? ''}`.trim().charAt(0).toUpperCase() || '?'} tone={blackMark ? 'gray' : 'violet'} />}
            title={project.name || project.bandl}
            titleExtra={current && <ListChip tone="primary">{i.t('superAdmin:projects.current')}</ListChip>}
            subtitle={`ID ${project.id}`}
            selected={current}
            muted={blackMark}
            onOpen={disabled ? undefined : onOpen}
            chips={<>
                {bundle && <ListChip copy={project.bandl}>{project.bandl}</ListChip>}
                <ListChip tone="info">{`${i.t('superAdmin:projects.plan')}: ${planName(project.pricing_plan)}`}</ListChip>
                <PaidChip project={project} />
                {blackMark && <ListChip tone="danger" icon={<StopOutlined />}>{i.t('superAdmin:projects.blackMark')}</ListChip>}
                {chips}
            </>}
            actions={
                <Button type={current ? 'default' : 'primary'} disabled={disabled} onClick={onOpen}>
                    {i.t('superAdmin:projects.open')}
                </Button>
            }
        />
    )
}
